import React from "react";
const SvgTest = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path
      d="M8 14.667a6.492 6.492 0 01-2.6-.525 6.732 6.732 0 01-2.116-1.425A6.732 6.732 0 011.859 10.6 6.492 6.492 0 011.334 8c0-.922.175-1.789.525-2.6a6.732 6.732 0 011.425-2.117c.6-.6 1.306-1.075 2.117-1.424A6.492 6.492 0 018 1.333c.922 0 1.789.175 2.6.526.81.35 1.516.825 2.116 1.425.6.6 1.075 1.305 1.425 2.116.35.811.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6a6.732 6.732 0 01-1.425 2.117c-.6.6-1.305 1.075-2.116 1.425a6.492 6.492 0 01-2.6.525zM4.9 7.484l.934-.95.933.95.717-.717-.95-.934.95-.933-.717-.716-.933.95-.933-.95-.717.716.95.933-.95.934.717.716zm3.1 5.85c1.478 0 2.737-.52 3.776-1.559 1.039-1.039 1.558-2.297 1.558-3.775 0-.733-.139-1.422-.417-2.066a5.408 5.408 0 00-1.15-1.7l-7.533 7.533a5.407 5.407 0 001.7 1.15 5.165 5.165 0 002.067.417zm1.367-1.6l-1.6-1.6.7-.717.9.9 1.667-1.65.7.7-2.367 2.366z"
    />
  </svg>
);
export default SvgTest;
